import React, { Component, useState } from 'react'
//import Collapsible from 'react-collapsible';
import moment from 'moment'
import Input from './Components/Input/Input'
import Dropdown from './Components/Dropdown/Dropdown'
import TagField from './Components/TagField/TagField'
import Date from './Components/Date/Date'
import DateTime from './Components/DateTime/DateTime'
import AssetContent from './Components/AssetContent/AssetContent'
import Transcription from './Components/Transcription/Transcription'
import AiVideoTags from './Components/aiVideoTags/AiVideoTags'
import AiImageTags from './Components/aiImageTags/AiImageTags'
import CropHints from './Components/cropHints/CropHint'
//import SocialCropHints from './Components/SocialCropHints/SocialCropHints'
import BeatLoader from "react-spinners/BeatLoader";
import assetsDriver from './helpers/assets'
import Sequence from './Components/Sequence/Sequence'

//import Amplify, { API, Auth } from 'aws-amplify'
//import awsconfig from './aws-exports';
import Modal from 'react-modal';
import Resizer from "react-image-file-resizer";

import ReactDOMServer from 'react-dom/server';

//import Sections from './Components/Sections/Sections'


import {
  Menu,
  MenuItem
  // MenuButton
} from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import './App.css'
import './plugin.css'
//API.configure(awsconfig);
//Auth.configure(awsconfig);



class App extends Component {
  constructor(props) {
    super(props)
    this.startCut = React.createRef();
    this.endCut = React.createRef();
    this.pluginSettings = window.pluginSettings
    // this.groupMapping = window.pluginSettings.groupMapping
    this.userProfile = window.elvisContext.app.userProfile
    this.isAdmin = window.elvisContext.app.userProfile.isAdmin
    this.currentFolderSelected = "/"
    this.configs = []
    this.gcdmLink = false
    this.openSections = []

    //window.assetsPluginContext.onUpdateContext = this.selectionUpdated.bind(this)

    window.elvisSubscriber = window.assetsPluginContext.subscribe(data => {
      window.elvisContext = data
      if (window.pluginType === "panel") {
        this.selectionUpdated()
      }
    });
    // console.log({ context: window.assetsPluginContext.onUpdateContext })


    this.state = {
      DoingAnAction: false,
      pluginActive: false,
      isProcessing: false,
      // openSections: [],
      gcdmData: null,
      marklogicData: null,
      values: {},
      activeConfig: {
        sections: []
      },
      processing: {

      }
    }
  }
  closeUpdatePanel() {
    this.setState({ DoingAnAction: false })
  }

  async moveAssets(button) {
    let assetPaths = window.elvisContext.activeTab.originalAssetSelection.map(x => x.assetPath)
    this.setState({ DoingAnAction: true, totalMoved: assetPaths.length })
    assetPaths.forEach((path, index) => {
      let split = path.split("/")
      window.apiClient.move({ source: path, target: `${button.movePath}/${split[split.length - 1]}` })
        .then(() => {
          this.setState({ moveAmmount: index + 1 })
          if (this.state.moveAmmount === this.state.totalMoved) {
            this.setState({ doingAnAction: false })
          }
        })
    })
    //this.setState({ DoingAnAction: false})
  }





  toggleClass(className, event) {
    console.log({ className, event })
    if (!event.target.classList.value.includes(className)) {
      event.target.classList.add(className)
    } else {
      event.target.classList.remove(className)
    }
  }

  toggleParent(data, event) {
    //console.log({ data })
    let openSections = this.openSections
    // if (openClose == 0) {
    //   openSections = openSections.filter(o => o !== id)
    // } else {
    //   openSections.push(id)
    // }

    // const settings = JSON.stringify({ openSections: openSections, last: this.state.activeConfig.name });
    // localStorage.setItem(`elvis.plugin.displaypanel-${this.userProfile.username}`, settings);
    // this.setState({ openSections })




    console.log(!openSections.includes(data.id))
    console.log(data.id)

    if (!openSections.includes(data.id)) {
      event.target.parentNode.classList.add(data.className)
      this.openSections.push(data.id)
    } else {
      this.openSections = this.openSections.filter(o => o !== data.id)
      event.target.parentNode.classList.remove(data.className)
    }

    const settings = JSON.stringify({ openSections: this.openSections, last: this.state.activeConfig.name });
    //console.log({ openSections })
    localStorage.setItem(`elvis.plugin.displaypanel-${this.userProfile.username}`, settings);
  }


  async componentDidMount() {
    let allowedConfigs = this.configPermissions()
    let userSettings
    let state = {}

    try {
      userSettings = JSON.parse(localStorage.getItem(`elvis.plugin.displaypanel-${this.userProfile.username}`)) //await get('settings')
    } catch (error) {

    }


    if (userSettings) {
      this.openSections = userSettings.openSections
      if (userSettings.last && allowedConfigs.filter(o => o.id === userSettings.last).length > 0) {
        state.activeConfig = allowedConfigs.filter(o => o.id === userSettings.last)[0]
      } else {
        state.activeConfig = allowedConfigs[0]
      }
    } else {
      state.activeConfig = allowedConfigs[0]
    }

    this.setState({ ...state }, () => {
      this.selectionUpdated()

    })




    // check browser storage for settings
    // if (userSettings) {
    //   this.setState({ openSections: config.openSections }, () => {
    //     this.selectionUpdated()
    //   })
    // } else {
    //   this.selectionUpdated()
    // }
  }

  componentWillUnmount() {
    window.elvisContext.updateCallback = null
  }

  configPermissions() {
    let configs = {}
    console.log({ userProfile: this.userProfile })
    this.props.config.tabs.forEach(config => {

      // if config matches the plugin type
      if (config[window.pluginType]) {
        config.groupMapping.forEach(group => {
          if (this.isAdmin) {
            let conf = config
            configs[config.name] = conf
          } else if (group.toLowerCase() === "all") {
            let conf = config
            configs[config.name] = conf
          } else {
            this.userProfile.groups.forEach(gr => {
              if (gr.toLowerCase() === group.toLowerCase()) {
                let conf = config
                configs[config.name] = conf
              }
            })
          }
        })
      }

    })

    // Object.keys(this.groupMapping).forEach(key => {
    //   let groups = this.groupMapping[key]
    //   groups.forEach(group => {
    //     if (group === 'admins' && this.isAdmin) {
    //       let conf = this.pluginSettings[key]
    //       configs[key] = conf
    //     } else if (group === 'all') {
    //       let conf = this.pluginSettings[key]
    //       configs[key] = conf
    //     } else {
    //       this.userProfile.groups.forEach(gr => {
    //         if (gr === group) {
    //           let conf = this.pluginSettings[key]
    //           configs[key] = conf
    //         }
    //       })
    //     }
    //   })
    // })

    let arr = []
    Object.keys(configs).forEach(key => {
      arr.push(configs[key])
    })
    this.configs = arr


    //console.log({ thisConfigHere: this.configs, test: window.pluginType })
    return arr
  }

  gcdmData() {
    return new Promise((resolve, reject) => {
      if (this.currentFolderSelected !== window.elvisContext.activeTab.folderSelection[0].name) {

        //   console.log({ selectionUpdated: window.elvisContext })
        this.currentFolderSelected = window.elvisContext.activeTab.folderSelection[0].name
        //   console.log(`folder selected ${this.currentFolderSelected}`)


        fetch("http://localhost:3001/artist", {
          method: 'GET', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            "key": "EFJKWefj29fr2jf9MDCEKJ3r290j209j02casjlkjfals",
            "artist": this.currentFolderSelected
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
        }).then(res => res.json())
          .then(
            (result) => {
              this.setState({
                gcdmData: result
              });
              resolve(result)
            },
            // Note: it's important to handle errors here
            // instead of a catch() block so that we don't swallow
            // exceptions from actual bugs in components.
            (error) => {
              console.log(error)
              this.setState({
                gcdmData: null,
              });
            }
          )
      }
    })

  }

  selectionUpdated(activeConfig = this.state.activeConfig) {
    this.thumbnailId = null


    this.setState({
      artistType: "",
      countryOfOrigin: "",
      displayName: "",
      formatCode: "",
      formatId: "",
      id: "",
      isActive: "",
      isDeleted: "",
      languageOfOrigin: "",
      legalName: "",
      majorGenreCode: "",
      majorGenreDescription: "",
      majorGenreId: "",
      minorGenreCode: "",
      minorGenreDescription: "",
      minorGenreId: "",
      relatedArtists: "",
      thumbnailUrl: null


    })




    // console.log({ originalAssetSelection: window.elvisContext.activeTab.originalAssetSelection })
    this.assetSelection = window.elvisContext.activeTab.originalAssetSelection
    // let metadata = {}
    let fieldCheck = []
    //console.log({activeConfig})
    activeConfig.sections.forEach(section => {
      section.rows.forEach(field => {
        //  console.log({field})
        if (field.fieldName) {
          fieldCheck.push(field)
        } else if (field.sectionType === 'grid') {
          field.fields.forEach(o => {
            if (o.fieldName) {
              fieldCheck.push(o)
            }
          })
        }
      })
    })

    this.filterData(fieldCheck)
      .then(metadata => {
        //  console.log({ metadata })
        if (this.assetSelection.length > 0) {
          this.setState({ pluginActive: true, values: metadata })
          // test() 
          // marklogicConnector({ assetId: this.assetSelection[0].id, clientId: window.config.clientid, method: "GET" }, this.state.marklogicData)
          //   .then(marklogicData => {
          //     this.setState({ marklogicData })
          //     console.log({ marklogicData })
          //   })

        } else if (this.assetSelection.length === 0) {
          this.setState({ pluginActive: false, values: metadata })
        }
        //console.log({ assetId: this.assetSelection[0].id, clientId: window.config.clientid })

      })
  }

  msToTime(duration) {
    //   let milliseconds = parseInt((duration % 1000) / 100)
    let seconds = Math.round((duration / 1000) % 60)
    let minutes = Math.floor((duration / (1000 * 60)) % 60)
    let hours = Math.floor((duration / (1000 * 60 * 60)) % 24)

    hours = (hours < 10) ? "0" + hours : hours;
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    return hours + ":" + minutes + ":" + seconds
  }




  filterData(fieldCheck, results = {}) {
    // console.log({ fieldCheck, results })
    return new Promise((resolve, reject) => {
      if (fieldCheck.length === 0) {
        let res = {}
        Object.keys(results).forEach(r => {
          if (results[r].size === 1) {
            let it = results[r].values()
            res[r] = it.next().value
          } else if (results[r].size > 1) {
            res[r] = "(multiple values)"
          }
        })
        resolve(res)
      } else {
        let fieldData = fieldCheck[0]
        this.assetSelection.every(asset => {
          let assetValue = asset.metadata[fieldData.fieldName] ? asset.metadata[fieldData.fieldName] : null

          if (fieldData.sectionType === 'tags' && fieldData.fieldName) {
            assetValue = asset.metadata[fieldData.fieldName] ? asset.metadata[fieldData.fieldName] : null
          } else if (fieldData.sectionType === 'date' && fieldData.fieldName) {
            assetValue = asset.metadata[fieldData.fieldName] ? assetValue.value : null
            // fieldValue = moment(fieldValue.value).format(field.momentFormat)
          } else if (fieldData.sectionType === 'datetime' && fieldData.field) {
            assetValue = asset.metadata[fieldData.fieldName] ? assetValue.value : null
            // fieldValue = moment(fieldValue.value).format(field.momentFormat)
          } else if (fieldData.sectionType === "formatted" && fieldData.fieldName) {
            assetValue = asset.metadata[fieldData.fieldName] ? assetValue.formatted : null
            // fieldValue = moment(fieldValue.value).format(field.momentFormat)
          } else if (fieldData.sectionType === 'milli2time' && fieldData.fieldName) {
            assetValue = this.msToTime(assetValue)
          }

          if (results[fieldData.fieldName]) {
            results[fieldData.fieldName].add(assetValue)
            if (results[fieldData.fieldName].size > 2) {
              return false
            } else {
              return true
            }
          } else {
            results[fieldData.fieldName] = new Set()
            results[fieldData.fieldName].add(assetValue ? assetValue : null)
            return true
          }

          // if (results[fieldData.field] && (assetValue !== results[fieldData.field]) && assetValue) {
          //   results[fieldData.field] = '(multiple values)'
          //   return false
          // } else if (assetValue) {
          //   results[fieldData.field] = assetValue ? assetValue : ''
          //   return true
          // } else {
          //   return true
          // }

        })

        setTimeout(() => {
          fieldCheck.shift()
          this.filterData(fieldCheck, results)
            .then((res) => {
              resolve(res)
            })
        }, 0)
      }

    })
  }

  async handleTriggerClick(id, openClose, e) {
    let openSections = this.openSections
    if (openClose === 0) {
      openSections = openSections.filter(o => o !== id)
    } else {
      openSections.push(id)
    }

    const settings = JSON.stringify({ openSections: openSections, last: this.state.activeConfig.name });
    localStorage.setItem(`elvis.plugin.displaypanel-${this.userProfile.username}`, settings);
    this.setState({ openSections })
  }


  updateSettings(params) {
    let settings = localStorage.getItem(`elvis.plugin.displaypanel-${this.userProfile.username}`)
    localStorage.setItem(`elvis.plugin.displaypanel-${this.userProfile.username}`, settings);
  }

  fieldValueChange(value) {

  }

  parseMetadata(data) {
    var regex = /(?<=\{)(.*?)(?=\})/;
    return new Promise((resolve, reject) => {
      // console.log({ userProfile: this.userProfile.username })
      let user = this.userProfile.username
      Object.keys(data).forEach(function (key) {
        var val = data[key];
        if (val.includes("{") && val.includes("}")) {
          var matched = val.match(regex)
          let matchedCase = matched[0]

          switch (matchedCase) {
            case "user":
              data[key] = val.replace(matchedCase, user).replace("{", "").replace("}", "")
              break;

            case "today":
              let dateToday = moment()
              console.log({ date: dateToday["_d"] })
              data[key] = val.replace(matchedCase, dateToday).replace("{", "").replace("}", "")
              break;
          }

          console.log(matchedCase)
        }

        // console.log({ key, val })

      });
      resolve(data)

    })

  }

  replaceQueryWithMetadataValues(query) {
    const regex = /{([^}]+)}/g; // Regular expression to match placeholders between { and }

    let querySplit = query.split("|")


    // Replace all occurrences of placeholders in the query string
    const modifiedQuery = query.replace(regex, (match, placeholder) => {
      if (this.assetSelection[0] && this.assetSelection[0].metadata.hasOwnProperty(placeholder)) {
        // If metadata value exists for the placeholder, replace it with the corresponding value
        return this.assetSelection[0].metadata[placeholder];
      }

      // if username
      if (match === "{user}") {
        match = this.userProfile.username
      }

      // If metadata value not found, return the original placeholder
      return match;
    });

    //console.log({ query, modifiedQuery, querySplit })



    return modifiedQuery; // Return the modified query string



  }

  async onButtonFunctionClick(button, e) {
    //this.setState({ DoingAnAction: true })
    // window.apiClient.move({source: ids, target: "/test-1"})
    if (button.buttonType === 'metadata') {
      let ids = []
      this.assetSelection.forEach(o => {
        ids.push(o.id)
      })
      ids = ids.join(' OR id:')

      let metadata = button.metafields

      this.parseMetadata(metadata)
        .then(res => {
          assetsDriver.updateBulk(`id:(${ids})`, res)
            .then(() => {
              this.setState({ DoingAnAction: false })
            })
        })
    } else if (button.buttonType === 'query') {
      let modifiedQuery = this.replaceQueryWithMetadataValues(button.query)

      window.assetsPluginContext.openSearch(modifiedQuery, button.sort ? button.sort : '')


    } else if (button.buttonType === 'browse') {
      window.assetsPluginContext.openBrowse(button.folderPath, button.includeSubFolders ? button.includeSubFolders : true, button.query ? button.query : '', button.sort ? button.sort : '')
    } else if (button.buttonType === "gcdmLink") {
      this.gcdmData()
        .then(res => {
          console.log(res)
          if (res.content && res.content[0] && res.content[0].displayName.toLowerCase() === this.currentFolderSelected.replace("/", "").toLowerCase())
            this.setState({
              artistType: res.content[0].artistType,
              countryOfOrigin: res.content[0].countryOfOrigin,
              displayName: res.content[0].displayName,
              formatCode: res.content[0].formatCode,
              formatId: res.content[0].formatId,
              id: res.content[0].id,
              isActive: res.content[0].isActive,
              isDeleted: res.content[0].isDeleted,
              languageOfOrigin: res.content[0].languageOfOrigin,
              legalName: res.content[0].legalName,
              majorGenreCode: res.content[0].majorGenreCode,
              majorGenreDescription: res.content[0].majorGenreDescription,
              majorGenreId: res.content[0].majorGenreId,
              minorGenreCode: res.content[0].minorGenreCode,
              minorGenreDescription: res.content[0].minorGenreDescription,
              minorGenreId: res.content[0].minorGenreId,
              relatedArtists: res.content[0].relatedArtists.length,






            })
        })
    } else if (button.buttonType === "Media Convert") {
      console.log({ asset: this.assetSelection, video: window.video })

      rulesEngineMediaConvert(window.assetsPluginContext._context.plugin[window.pluginType].configProperties, this.assetSelection, window.video)
        .then(res => {
          console.log({ res, test: window.assetsPluginContext })
        })
    } else if (button.buttonType === "Generate Images") {
      e.target.disabled = true;
      e.target.textContent = "Processing..."
      e.target.style.color = '#0095e0';
      // let promiseArray = [];
      // let parsedurl = this.replaceQueryWithMetadataValues(button.url);
      // let ids;

      try {
        const res = await window.apiClient.search({ q: `relatedTo:${this.assetSelection[0].id}`, appendRequestSecret: true, num: 1000 });
        let length = res.hits.length
        console.log({ e })
        let percentage = (1 / length) * 100

        e.target.innerHTML = ReactDOMServer.renderToString(
          <div >
            <BeatLoader color="#0095e0" size={10} />
            {percentage}%
          </div>
        );
        //Iterate through the hits from the search results
        for (const [index, item] of res.hits.entries()) {
          const briefs = await window.apiClient.search({ q: `isbn:${this.assetSelection[0].metadata.isbn} cf_selectedAssetID: ${item.id} type: "brief"`, num: 1000 });
          // Process each brief in the briefs hits

          for (const brief of briefs.hits) {
            if (item.metadata.assetType === "jpg" || item.metadata.assetType === "jpeg" || item.metadata.assetType === "png") {
              await this.generateImage(item, brief, e, length, index)
            } else {
              await this.MoveAsset(item, brief, e, length, index)
              alert(`${item.metadata.name} form Brief: ${brief.id} Invalid assetType: ${item.metadata.assetType}`);
            }
          }
        }



        window.assetsPluginContext.openBrowse(`/Output/${this.assetSelection[0].metadata.isbn}/`, true)

        // window.open(parsedurl + ids);
      } catch (error) {
        console.log({ error });
        alert(error.message);

      }

    } else if (button.buttonType === "Compliance Report") {

      // const complianceReport = await API.post("authAPI", "/complianceReport", {
      //   'content-type': "text/plain",
      //   "access-control-allow-origin": "*",
      //   "body": {isbn: this.assetSelection[0].metadata.isbn, url: window.DAMURL},
      //   "headers": {
      //     "x-api-key": window.apiKey
      //   }
      // });




      // if (complianceReport != '') {
      //   let json = JSON.parse(complianceReport)
      //   window.open(json.url)
      // } else {
      //   alert("no Data Found")
      // }

    }
  }




  generateImage(item, brief, e, length, index) {
    return new Promise((resolve, reject) => {
      let percentage = (index / length) * 100;
      var http = require('http');
      let body;
      let url
      console.log({ index, length });
      e.target.innerHTML = ReactDOMServer.renderToString(
        <div>
          <BeatLoader color="#0095e0" size={10} />
          {percentage}%
        </div>
      );
      let x = null;
      let y = null;

      if (brief.metadata.cf_dimensionRequiredX) {
        x = brief.metadata.cf_dimensionRequiredX;
      }
      if (brief.metadata.cf_dimensionRequiredY) {
        y = brief.metadata.cf_dimensionRequiredY;
      }
      console.log({ item })
      if (x === null || y === null) {
        url = item.originalUrl
        x = 99999
        y = 99999
      } else {
        url = item.previewUrl
      }

      http.get(url, (resp) => {
        resp.setEncoding('base64');
        body = "data:" + resp.headers["content-type"] + ";base64,";
        resp.on('progress', (data) => {
          console.log({ data });
        });
        resp.on('data', (data) => {
          body += data;
        });
        resp.on('end', () => {
          const file = DataURIToBlob(body);
          try {
            Resizer.imageFileResizer(
              file,
              x,
              y,
              "JPEG",
              80,
              0,
              (uri) => {

                let metadata = {
                  assetPath: `/Output/${brief.metadata.isbn}/` + brief.metadata.cf_filenameID

                }
                try {
                  window.apiClient.create({
                    Filedata: DataURIToBlob(uri),
                    metadata: JSON.stringify(metadata)
                  }).then(() => {
                    resolve();
                  }).catch((error) => {
                    if (error.message === "java.lang.IllegalStateException: File has already been moved - cannot be transferred again") {
                      window.apiClient.remove({
                        q: `assetPath: /Output/${brief.metadata.isbn}/${brief.metadata.cf_filenameID}.jpg`,
                        appendRequestSecret: true
                      })
                        .then((res => {
                          window.apiClient.create({
                            Filedata: DataURIToBlob(uri),
                            metadata: JSON.stringify(metadata)
                          }).then(() => {
                            resolve();
                          })
                        }))
                    }

                    resolve();
                    //reject(error); // Reject the promise with the error
                  });
                } catch (error) {
                  resolve();
                  //reject(error); // Reject the promise with the error
                }
              },
              "base64",
              1,
              1
            );
          } catch (err) {
            reject(err); // Reject the promise with the error
          }
        });
      }).on('error', (e) => {
        reject(e); // Reject the promise with the error
        console.log(`Got error: ${e.message}`);
      });
    });
  }

  MoveAsset(item, brief, e, length, index) {
    return new Promise((resolve, reject) => {
      console.log({ item })
      window.apiClient.copy({ source: item.metadata.assetPath, target: `/Output/${brief.metadata.isbn}/${brief.metadata.cf_filenameID}.jpg` })
        .then(res => {
          resolve()
        })
    });
  }


  doEvent(obj, event) {
    /* Created by David@Refoua.me */
    var event = new Event(event, { target: obj, bubbles: true });
    return obj ? obj.dispatchEvent(event) : false;
  }

  onLinkClick(field, value, e) {
    e.preventDefault()
    console.log({ field, value })
    if (value !== '(multiple values)') {
      window.assetsPluginContext.openBrowse(value, true)
    }
  }

  onAssetLinkClick(field, value, e) {
    e.preventDefault()
    console.log({ field, value })
    if (value !== '(multiple values)') {
      window.assetsPluginContext.openAssets([value], true)
    }
  }




  setConfig(name) {
    let conf = this.configs.filter(o => o.name === name)
    try {
      let userSettings = JSON.parse(localStorage.getItem(`elvis.plugin.displaypanel-${this.userProfile.username}`)) //await get('settings')
      userSettings.last = conf[0].id
      localStorage.setItem(`elvis.plugin.displaypanel-${this.userProfile.username}`, JSON.stringify(userSettings))
    } catch (error) {
      console.log({ error })
      let userSettings = {
        openSections: [],
        last: conf[0].name
      }
      localStorage.setItem(`elvis.plugin.displaypanel-${this.userProfile.username}`, JSON.stringify(userSettings))
    }
    this.setState({ activeConfig: conf[0] }, () => {
      this.selectionUpdated(conf[0])
    })
  }


  onAppClick(e) {
    // e.stopPropagation()
  }

  getFunction(field, values) {
    let assetDomain
    try {
      assetDomain = window.elvisContext.activeTab.originalAssetSelection[0].assetDomain
    } catch (error) {
      assetDomain = "none"
    }


    let disabled = this.assetSelection ? this.assetSelection.length === 0 : true
    if (field[assetDomain]) {
      switch (field.actionType) {
        case "button":

          if (field.alwaysOn === true) {
            disabled = false
          }
          return (
            <div className="fieldRow">
              <div style={{ width: '100%', textAlign: 'left' }}>
                <button disabled={disabled} style={field.style ? field.style : {}} onClick={this.onButtonFunctionClick.bind(this, field)}>{field.displayName}</button>
              </div>
            </div>
          )
        case "sequence":
          console.log(field)

          return (
            <Sequence field={field} />
          )
        case "transcription":
          let transcribeData
          if (this.state.marklogicData) {
            this.state.marklogicData.forEach(data => {
              if (data.uri.includes("googleVision-VideoTranscribe.json")) {
                transcribeData = data.content
              }
            })
          }

          return (
            <Transcription
              aiData={transcribeData}
            />
          )
        case "aiVideoTags":
          let labelData
          if (this.state.marklogicData) {
            this.state.marklogicData.forEach(data => {
              if (data.uri.includes("googleVision-VideoLabels.json")) {
                labelData = data.content
              }
            })
          }
          return (
            <AiVideoTags
              aiData={labelData}
            />
          )
        case "aiImageTags":
          let tagData
          if (this.state.marklogicData) {
            // console.log({ marklogicData: this.state.marklogicData })
            this.state.marklogicData.forEach(data => {
              if (data.uri.includes("googleVision-ObjectDetection.json")) {
                tagData = data.content
                console.log({ tagData })
              }
            })
          }
          return (
            <AiImageTags
              aiData={tagData}
            />
          )
        case "crop hints":
          let cropData

          if (this.state.marklogicData) {
            console.log({ marklogicData: this.state.marklogicData })
            this.state.marklogicData.forEach(data => {
              if (data.uri.includes("googleVision-CropHints")) {
                data.content.uri = data.uri
                cropData = data.content
                console.log({ cropData })
              }
            })
          }
          return (
            <CropHints
              aiData={cropData}
              cropperRef={window.cropperRef}
            />
          )
        case "Social crop hints":
          let cropSocialData
          let customCropData
          if (this.state.marklogicData) {
            // console.log({ marklogicData: this.state.marklogicData, field })
            this.state.marklogicData.forEach(data => {
              if (data.uri.includes("googleVision-CropHints")) {
                data.content.uri = data.uri
                cropSocialData = data.content
              }
              if (data.uri.includes("customSocialCrops.json")) {
                console.log({ content: data.content })
                customCropData = data.content

              }
            })
          }
          return (
            <></>
            // <SocialCropHints
            //   cropperRef={window.cropperRef} aiData={cropSocialData} customCropData={customCropData} showDefaultSocialCrops={field.includeDefault} customCropsFromConfig={field.customCrops}
            // />
          )
      }
    } else {
      return <></>
    }


  }

  getField(field, values, isGrid = false) {
    let assetDomain
    try {
      assetDomain = window.elvisContext.activeTab.originalAssetSelection[0].assetDomain
    } catch (error) {
      assetDomain = "none"
    }



    //console.log({ field, values, assetDomain: assetDomain })
    let labelClass = 'ems_item_label'
    let rowClass = 'ems_tool_group-content-item'
    if (isGrid) {
      labelClass = 'gridLabel'
      rowClass = 'gridItem'
    }
    //console.log(window.pluginType)

    if (field[assetDomain]) {
      switch (field.sectionType) {
        case "hr":
          return (
            <div className="hr" style={field.colour ? { borderColor: field.colour } : {}} />
          )
        // break
        case "gap5px":
          return (
            <div className="gap5px" />
          )
        //  break
        case "gap10px":
          return (
            <div className="gap10px" />
          )
        //  break
        case "gap20px":
          return (
            <div className="gap20px" />
          )
        // break
        case "grid":
          // console.log({ field })
          let fields = field.fields
          let elements = []
          fields.forEach(gridField => {
            if (gridField.entityType === 'Action') {
              let newField = this.getFunction(gridField, values, true)
              elements.push(newField)
            } else {
              let newField = this.getField(gridField, values, true)
              //   console.log({ newField })
              elements.push(newField)
            }

            // elements.push(
            //   <div className="gridItem">
            //     <div className="label gridLabel">
            //       {gridField.label}
            //     </div>
            //     <Input canEdit={gridField.editable} noGrow={true} assets={this.assetSelection} value={values[gridField.field]} assetsDriver={this.assetsDriver} assetHelper={assetsDriver} field={gridField.field} />
            //   </div>
            // )
          })
          return (
            <div className="gridContainer">
              {elements}
            </div>
          )
        //  break
        case "tags":
          return (
            <div className={rowClass}>
              <div className={labelClass}>
                {field.displayName}
              </div>

              <TagField
                onClick={(e) => e.stopPropagation()}
                displayName={field.displayName}
                inputType={field.tagType}
                inputValues={field.values}
                canEdit={!field.disabled}
                assets={this.assetSelection}
                value={values[field.fieldName] ? values[field.fieldName] : []}
                onlyFromValues={field.onlyFromValues}
                assetsDriver={this.assetsDriver}
                assetHelper={assetsDriver}
                field={field.fieldName}
                tagColour={this.props.config.colour}
                tagBackground={this.props.config.backgroundColour}
              />
            </div>
          )
        //  break
        case "datetime":
          return (
            <div className={rowClass}>
              <div className={labelClass}>
                {/* {console.log({ field, value: values })} */}
                {field.displayName}
              </div>
              <DateTime
                onClick={(e) => e.stopPropagation()}
                canEdit={!field.disabled}
                assets={this.assetSelection}
                value={values[field.fieldName] ? values[field.fieldName].value : null}
                assetsDriver={this.assetsDriver}
                assetHelper={assetsDriver}
                field={field.fieldName}
                format={field.format}
                tagColour={this.props.config.colour}
                tagBackground={this.props.config.backgroundColour}
              />
            </div>
          )
        // break
        case "date":
          console.log({ field, values: values[field.fieldName] })
          return (
            <div className={rowClass}>
              <div className={labelClass}>
                {field.displayName}
              </div>
              <Date onClick={(e) => e.stopPropagation()}
                canEdit={!field.disabled}
                assets={this.assetSelection}
                value={values[field.fieldName] ? values[field.fieldName] : null}
                assetsDriver={this.assetsDriver}
                assetHelper={assetsDriver}
                field={field.fieldName}
                format={field.format}
                tagColour={this.props.config.colour}
                tagBackground={this.props.config.backgroundColour}
              />
            </div>
          )
        //  break
        case "text":
          return (
            <div className={rowClass} id={field.fieldName} editable={!field.disabled}>
              <div className={labelClass}>
                {field.displayName}
              </div>
              <Input
                canEdit={!field.disabled}
                assets={this.assetSelection}
                value={values[field.fieldName]}
                assetsDriver={this.assetsDriver}
                assetHelper={assetsDriver}
                field={field.fieldName}
              />
            </div>
          )
        // break
        case "state":
          return (
            <div className={rowClass} id={field.field}>
              <div className={labelClass}>
                {field.displayName}
              </div>
              <Input
                canEdit={!field.disabled}
                assets={this.assetSelection}
                value={this.state[field.field]}
                assetsDriver={this.assetsDriver}
                assetHelper={assetsDriver}
                field={field.field}
              />
            </div>
          )
        // break
        case "number":
          return (
            <div className={rowClass}>
              <div className={labelClass}>
                {field.displayName}
              </div>
              <Input
                canEdit={!field.disabled}
                assets={this.assetSelection}
                value={values[field.fieldName]}
                assetsDriver={this.assetsDriver}
                assetHelper={assetsDriver}
                field={field.fieldName}
                type="number"
              />
            </div>
          )
        //  break
        case "array":
          return (
            <div className={rowClass}>
              <div className={labelClass}>
                {field.displayName}
              </div>
              <Input
                canEdit={!field.disabled}
                assets={this.assetSelection}
                value={values[field.field]}
                assetsDriver={this.assetsDriver}
                assetHelper={assetsDriver}
                field={field.field}
              />
            </div>
          )
        //  break
        case "dropdown":
          return (
            <div className={rowClass}>
              <div className={labelClass}>
                {field.displayName}
              </div>
              <Dropdown
                assets={this.assetSelection}
                values={["",].concat(field.values)}
                default={values[field.fieldName]}
                assetsDriver={this.assetsDriver}
                onValueChange={this.fieldValueChange.bind(this)}
                assetHelper={assetsDriver}
                field={field.fieldName}
                source={field.source}
              />
            </div>
          )
        //  break
        case "link":
          return (
            <div className={rowClass}>
              <div className={labelClass}>
                {field.displayName}
              </div>
              <div className="text">
                <a href="" onClick={this.onLinkClick.bind(this, field, values[field.fieldName])} >{values[field.fieldName]}</a>
              </div>
            </div>
          )
        //  break
        case "Asset Link":
          return (
            <div className={rowClass}>
              <div className={labelClass}>
                {field.displayName}
              </div>
              <div className="text">
                <a href="" onClick={this.onAssetLinkClick.bind(this, field, values[field.fieldName])} >{values[field.fieldName]}</a>
              </div>
            </div>
          )

        //  break
        default:
          return (
            <div className={rowClass}>
              <div className={labelClass}>
                {field.displayName}
              </div>
              <div className="text">
                {/* {console.log({ field, x: 123, values })} */}
                {values[field.fieldName]}
              </div>

            </div>
          )
        // break
      }
    } else {
      return <></>
    }


  }

  getElement(type, field) {

    switch (type) {
      case "hr":
        return (
          <div className="hr" style={field.colour ? { borderColor: field.colour } : {}} />
        )
        break
    }
  }
  render() {
    const {
      processing,
      pluginActive,
      openSections,
      values
    } = this.state




    const Sections = ({ data }) => {
      if (!data) return null
      let returnData = []
      // console.log({ data })
      data.forEach(section => {
        //  console.log({ section })
        // console.log({ assets: this.assetSelection })
        //let className = "titleSection"
        let className = this.assetSelection && this.assetSelection.length === 0 && section.disabledNoSelection === true ? "titleSection-disabled" : "titleSection"
        let open = this.openSections.indexOf(section.label) > -1 ? true : false




        let fields = section.rows.map(field => {
          if (field.entityType === 'Action') {
            return this.getFunction(field, values)
          } else if (field.entityType === 'HTML Element') {
            return (
              <div className="hr" style={field.colour ? { borderColor: field.colour } : {}} />
            )
          } else {

            //   console.log({ field: this.getField(field, values) })
            return this.getField(field, values)
          }

        })

        //  console.log({ fields })



        returnData.push(
          <div className={`ems_tool_group${open ? " is-open" : ""}`}>
            <div className="ems_tool_group-header" onClick={this.toggleParent.bind(this, { id: section.label, className: 'is-open' })}>
              <div className="ems_icon ems_icon_angle-right" onClick={this.toggleParent.bind(this, { id: section.label, className: 'is-open' })}></div>{section.label}
            </div>
            <div className="ems_tool_group-content">

              <div className="ems_tool_group-content-inner">
                {section.description ?
                  <div className="ems_tool_group-content-item">
                    <div className="ems_description">{section.description}</div>
                  </div>
                  : null
                }
                {fields}
              </div>
            </div>
          </div>
        )
      });
      return returnData
    }

    const TopMenu = ({ data }) => {
      const [text, setText] = useState('');

      const handleMenuClick = e => {
        this.setConfig(e.value)
        // this.selectionUpdated(e.value)


        //setText(t => t + `[Menu] ${e.value} clicked\n\n`);
      };

      const handleItemClick = e => {
        setText(t => t + `[MenuItem] ${e.value} clicked\n`);
        //  this.selectionUpdated()
      };



      let menuItems = []
      this.configs.forEach(conf => {
        menuItems.push(
          <MenuItem value={conf.name} key={conf.name} onClick={handleItemClick}>
            {this.state.activeConfig.name === conf.name ? <div style={{ color: '#0095e0', fontWeight: '700' }}>{conf.name}</div> : <div>{conf.name}</div>}
          </MenuItem>
        )
      })

      menuItems.push(
        <MenuItem key="version">
          <div style={{ color: "lightgrey" }}>Version 1.2.0</div>
        </MenuItem>

      )

      return < div >
        <Menu menuButton={<img className="menuicon" src="data:image/png;base64,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"></img>}
          onClick={handleMenuClick}>
          {menuItems}
        </Menu>

      </div >
    }

    let doingAnAction = this.state.DoingAnAction

    return (

      <div className="App" onClick={this.onAppClick.bind(this)}>


        {window.elvisContext.plugin.type === "action" ?
          <AssetContent marklogicData={this.state.marklogicData} ref={this.startCut} /> :
          <></>
        }

        {doingAnAction ?
          <div className="sections" >
            <button onClick={this.closeUpdatePanel.bind(this)} style={{ width: "30px", padding: "revert" }}>X</button>
            <div className="ems_header_title ems_tools_title" style={{ marginTop: "80%" }}>Updating Metadata. Please do not navigate away from this page.</div>
            <BeatLoader color={"#0095e0"} css={{ top: "40%", left: "45%", position: "absolute", }} size={10} />
          </div>
          :
          <div className="sections" style={{ left: window.elvisContext.plugin.type === "action" ? "70%" : "0" }}>
            <div className="ems_header_block ems_tools_header">
              <div className="ems_header_title ems_tools_title">{this.state.activeConfig.name}</div>
              <TopMenu />
            </div>
            <div className="description">{this.state.activeConfig.description}</div>
            <div className="hr" />
            <Sections data={this.state.activeConfig.sections} key="sgdgs" />
          </div>
        }

      </div>

    )
  }
}

App.propTypes = {

};

export default App



async function marklogicConnector(body, data) {
  //console.log({ checker: data })
  try {
    // const config = await API.post("authAPI", "/marklogicConnector", {
    //   'content-type': "text/plain",
    //   "access-control-allow-origin": "*",
    //   "body": body,
    //   "headers": {
    //     "x-api-key": window.apiKey
    //   }
    // });

    // return config
  } catch (err) { console.log(`error fetching config ${err}`) }
}

async function rulesEngineMediaConvert(rulesEngineData, assetData, startEnd) {

  let data = {
    rulesEngineData,
    assetData,
    startEnd,
    type: "mediaConvert"
  }

  //console.log(JSON.stringify(data))
  try {
    // const config = await API.post("authAPI", "/rulesEngineConnector", {
    //   'content-type': "application/json",
    //   "access-control-allow-origin": "*",
    //   "body": data,
    //   "headers": {
    //     "x-api-key": window.apiKey
    //   }
    // });

    // return config
  } catch (err) { console.log(`error connecting to rules engine ${err}`) }
}



function DataURIToBlob(dataURI) {
  const splitDataURI = dataURI.split(',')
  const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
  const mimeString = splitDataURI[0].split(':')[1].split(';')[0]

  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++)
    ia[i] = byteString.charCodeAt(i)

  return new Blob([ia], { type: mimeString })
}
